import ListView from 'view/listView';

class NewsListView extends ListView {
  constructor() {
    super();
    this.name = 'news';
    this.className = 'NewsListView';
  }
}
export default NewsListView;